import { ExpandMore } from "@mui/icons-material";
import { Collapse, Divider, Grid, Icon, LinearProgress, List, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { LIGHT_GREY_COLOR } from "../../_const/color.const";
import { accountService } from "../../_services/accounts.service";
import { FormTemplateTypeEnum } from "../../_common/enum/forms/fomTemplateType.enum";
import { FormStatusEnum } from "../../_common/enum/forms/formStatus.enum";
import { handleErrorResponse } from "../../_helpers/handleResponse.helper";
import { formTemplateService } from "../../_services/formTemplate.service";

export function UserNavigation(params: { onSelect(): void }) {

    let navigate = useNavigate();

    const [isLicensesOpen, setIsLicensesOpen] = useState(false);
    const [isInsurancesOpen, setIsInsurancesOpen] = useState(false);
    const [isQuestionnaireOpen, setIsQuestionnaireOpen] = useState(false);
    const [isQuestionnaireLoading, setIsQuestionnaireLoading] = useState(true);
    const [questionnaires, setQuestionnaires] = useState([]);

    const [activeIndex, setActiveIndex] = useState<number | null>(null);

    useEffect(() => {
        if (isQuestionnaireOpen && !questionnaires.length) {
            fetchQuestionnaires();
        }
    }, [isQuestionnaireOpen]);

    function fetchQuestionnaires() {

        setIsQuestionnaireLoading(true)
        return formTemplateService
            .getAllByType(FormTemplateTypeEnum.Questionnaire, FormStatusEnum.Approved)
            .then(
                (json) => {
                    setQuestionnaires(json)
                }, handleErrorResponse
            )
            .finally(() => {
                setIsQuestionnaireLoading(false);
            });
    }

    return (
        <Grid container sx={{ maxWidth: 'xl', margin: { xs: '0px auto', md: '20px auto' } }}>

            <Grid item xs={12} mb="8px">
                <List>
                    {(accountService.isOrganiser || accountService.isAdmin) &&
                        <>
                            <ListItemButton key={"Users"} onClick={(e) => { setActiveIndex(0); params.onSelect(); navigate("Users"); }}>
                                <ListItemIcon sx={{ minWidth: "40px" }}>
                                    <Icon>people</Icon>
                                </ListItemIcon>
                                <ListItemText primary="User Search" />
                            </ListItemButton>
                            <Divider />
                        </>
                    }

                    <ListItemButton key={"Personal Information"} onClick={(e) => { setActiveIndex(0); params.onSelect(); navigate(""); }}>
                        <ListItemIcon sx={{ minWidth: "40px" }}>
                            <Icon>person</Icon>
                        </ListItemIcon>
                        <ListItemText primary="Personal Information" />
                    </ListItemButton>

                    <ListItemButton key={"Licenses"} onClick={(e) => setIsLicensesOpen(!isLicensesOpen)}>
                        <ListItemIcon sx={{ minWidth: "40px" }}>
                            <Icon>assignment_turned_in</Icon>
                        </ListItemIcon>
                        <ListItemText primary="Licences" />
                        {isLicensesOpen ? <ExpandMore /> : <Icon>chevron_right</Icon>}
                    </ListItemButton>

                    <Collapse in={isLicensesOpen} timeout="auto" unmountOnExit>
                        <List component="div">

                            <ListItemButton sx={{ pl: 4, marginLeft: '26px', paddingLeft: '12px', borderLeft: '1px solid #deded3', bgcolor: LIGHT_GREY_COLOR }} onClick={e => { navigate("MotorLicences"); params.onSelect(); }}>
                                <ListItemIcon sx={{ minWidth: "40px" }}>
                                    <Icon fontSize="small" color="disabled">directions_car</Icon>
                                </ListItemIcon>

                                <ListItemText
                                    primaryTypographyProps={{ fontSize: '14px' }}
                                    primary={"Competition"} />
                            </ListItemButton>

                            <ListItemButton sx={{ pl: 4, marginLeft: '26px', paddingLeft: '12px', borderLeft: '1px solid #deded3', bgcolor: LIGHT_GREY_COLOR }} onClick={e => { navigate("OfficialLicences"); params.onSelect(); }}>
                                <ListItemIcon sx={{ minWidth: "40px" }}>
                                    <Icon fontSize="small" color="disabled">accessibility</Icon>
                                </ListItemIcon>

                                <ListItemText
                                    primaryTypographyProps={{ fontSize: '14px' }}
                                    primary={"Official"} />
                            </ListItemButton>

                            <ListItemButton sx={{ pl: 4, marginLeft: '26px', paddingLeft: '12px', borderLeft: '1px solid #deded3', bgcolor: LIGHT_GREY_COLOR }} onClick={e => { navigate("Media"); params.onSelect(); }}>
                                <ListItemIcon sx={{ minWidth: "40px" }}>
                                    <Icon fontSize="small" color="disabled">radio</Icon>
                                </ListItemIcon>

                                <ListItemText
                                    primaryTypographyProps={{ fontSize: '14px' }}
                                    primary={"Media"} />
                            </ListItemButton>

                            <ListItemButton sx={{ pl: 4, marginLeft: '26px', paddingLeft: '12px', borderLeft: '1px solid #deded3', bgcolor: LIGHT_GREY_COLOR }} onClick={e => { navigate("MinorEntrant"); params.onSelect(); }}>
                                <ListItemIcon sx={{ minWidth: "40px" }}>
                                    <Icon fontSize="small" color="disabled">supervisor_account</Icon>
                                </ListItemIcon>

                                <ListItemText
                                    primaryTypographyProps={{ fontSize: '14px' }}
                                    primary={"Minor Entrant"} />
                            </ListItemButton>

                            <ListItemButton sx={{ pl: 4, marginLeft: '26px', paddingLeft: '12px', borderLeft: '1px solid #deded3', bgcolor: LIGHT_GREY_COLOR }} onClick={e => { navigate("OneDayEvent"); params.onSelect(); }}>
                                <ListItemIcon sx={{ minWidth: "40px" }}>
                                    <Icon fontSize="small" color="disabled">event</Icon>
                                </ListItemIcon>

                                <ListItemText
                                    primaryTypographyProps={{ fontSize: '14px' }}
                                    primary={"One Day"} />
                            </ListItemButton>

                        </List>
                    </Collapse>


                    <ListItemButton key={"Insurance"} onClick={(e) => setIsInsurancesOpen(!isInsurancesOpen)}>
                        <ListItemIcon sx={{ minWidth: "40px" }}>
                            <Icon>car_crash</Icon>
                        </ListItemIcon>
                        <ListItemText primary="Insurance" />
                        {isInsurancesOpen ? <ExpandMore /> : <Icon>chevron_right</Icon>}
                    </ListItemButton>

                    <Collapse in={isInsurancesOpen} timeout="auto" unmountOnExit>
                        <List component="div">

                            <ListItemButton sx={{ pl: 4, marginLeft: '26px', paddingLeft: '12px', borderLeft: '1px solid #deded3', bgcolor: LIGHT_GREY_COLOR }} onClick={e => { navigate("insurance/IRDS"); params.onSelect(); }}>
                                <ListItemIcon sx={{ minWidth: "40px" }}>
                                    <Icon fontSize="small" color="disabled">attach_money</Icon>
                                </ListItemIcon>

                                <ListItemText
                                    primaryTypographyProps={{ fontSize: '14px' }}
                                    primary={"IRDS"} />
                            </ListItemButton>

                            <ListItemButton sx={{ pl: 4, marginLeft: '26px', paddingLeft: '12px', borderLeft: '1px solid #deded3', bgcolor: LIGHT_GREY_COLOR }} onClick={e => { navigate("insurance/BRDS"); params.onSelect(); }}>
                                <ListItemIcon sx={{ minWidth: "40px" }}>
                                    <Icon fontSize="small" color="disabled">attach_money</Icon>
                                </ListItemIcon>

                                <ListItemText
                                    primaryTypographyProps={{ fontSize: '14px' }}
                                    primary={"BRDS"} />
                            </ListItemButton>

                            <ListItemButton sx={{ pl: 4, marginLeft: '26px', paddingLeft: '12px', borderLeft: '1px solid #deded3', bgcolor: LIGHT_GREY_COLOR }} onClick={e => { navigate("Database"); params.onSelect(); }}>
                                <ListItemIcon sx={{ minWidth: "40px" }}>
                                    <Icon fontSize="small" color="disabled">storage</Icon>
                                </ListItemIcon>

                                <ListItemText
                                    primaryTypographyProps={{ fontSize: '14px' }}
                                    primary={"View Database"} />
                            </ListItemButton>

                        </List>
                    </Collapse>


                    <ListItemButton key={"Insurance"} onClick={(e) => setIsQuestionnaireOpen(!isQuestionnaireOpen)}>
                        <ListItemIcon sx={{ minWidth: "40px" }}>
                            <Icon>question_answer</Icon>
                        </ListItemIcon>
                        <ListItemText primary="Questionnaire" />
                        {isQuestionnaireOpen ? <ExpandMore /> : <Icon>chevron_right</Icon>}
                    </ListItemButton>

                    <Collapse in={isQuestionnaireOpen} timeout="auto" unmountOnExit>
                        <List component="div">

                            {isQuestionnaireLoading && <LinearProgress />}
                            {(!isQuestionnaireLoading && questionnaires?.length < 1) && <p>No available questionnaires</p>}
                            {(!isQuestionnaireLoading && questionnaires.length > 0) && questionnaires.map((q: any) =>
                                <ListItemButton sx={{ pl: 4, marginLeft: '26px', paddingLeft: '12px', borderLeft: '1px solid #deded3', bgcolor: LIGHT_GREY_COLOR }} onClick={e => navigate("Questionnaire/" + q.name)}>
                                    <ListItemIcon sx={{ minWidth: "40px" }}>
                                        <Icon fontSize="small" color="disabled">psychology_alt</Icon>
                                    </ListItemIcon>

                                    <ListItemText
                                        primaryTypographyProps={{ fontSize: '14px' }}
                                        primary={q.name} />
                                </ListItemButton>
                            )}

                        </List>
                    </Collapse>

                    <ListItemButton key={"My Forms"} onClick={(e) => { setActiveIndex(0); navigate("Forms"); params.onSelect(); }}>
                        <ListItemIcon sx={{ minWidth: "40px" }}>
                            <Icon>article</Icon>
                        </ListItemIcon>
                        <ListItemText primary="My Forms" />
                    </ListItemButton>

                    <ListItemButton key={"Uploaded Files"} onClick={(e) => { setActiveIndex(0); navigate("Uploads"); params.onSelect(); }}>
                        <ListItemIcon sx={{ minWidth: "40px" }}>
                            <Icon>drive_folder_upload</Icon>
                        </ListItemIcon>
                        <ListItemText primary="Uploaded Files" />
                    </ListItemButton>

                    <ListItemButton key={"Personal Information Events"} onClick={(e) => { setActiveIndex(0); navigate("Events"); params.onSelect(); }}>
                        <ListItemIcon sx={{ minWidth: "40px" }}>
                            <Icon>emoji_events</Icon>
                        </ListItemIcon>
                        <ListItemText primary="Events" />
                    </ListItemButton>

                    <ListItemButton key={"Fines"} onClick={(e) => { setActiveIndex(0); navigate("Fines"); params.onSelect(); }}>
                        <ListItemIcon sx={{ minWidth: "40px" }}>
                            <Icon>gavel</Icon>
                        </ListItemIcon>
                        <ListItemText primary="Fines" />
                    </ListItemButton >

                </List >
            </Grid >

        </Grid >

    );

}
